import { SwipePresetId } from './map.types';

export interface SwipeLayerSpec {
  url: string;
  title: string;
}

export interface SwipePreset {
  id: SwipePresetId;
  label: string;
  description: string;
  leadingLayers: SwipeLayerSpec[];   // visible LEFT of the divider
  trailingLayers: SwipeLayerSpec[];  // visible RIGHT of the divider
  direction: 'horizontal' | 'vertical';
  initialPosition: number; // 0-100, percent from left (horizontal)
}

// 'project-design-vs-asbuilt' is built dynamically from each project's design
// reference layers (leading) and the SiteNotes-native as-built layers (trailing),
// so it's intentionally absent from this static map.
export const SWIPE_PRESETS: Record<
  Exclude<SwipePresetId, 'off' | 'project-design-vs-asbuilt'>,
  SwipePreset
> = {
  'cip-vs-existing-streets': {
    id: 'cip-vs-existing-streets',
    label: 'Design vs Existing Streets',
    description: 'Greeley CIP projects (design) vs Weld County street centerlines',
    leadingLayers: [
      {
        url: 'https://services.arcgis.com/pfd9xSB0fCRnWvDl/ArcGIS/rest/services/InfrastructureProjects_capitalimprovementplan_f591509610ce45e6a910f3852498f4a4/FeatureServer/0',
        title: 'CIP — Design / Planned',
      },
    ],
    trailingLayers: [
      {
        url: 'https://services.arcgis.com/pfd9xSB0fCRnWvDl/ArcGIS/rest/services/WeldCounty_Street_Centerlines2021/FeatureServer/0',
        title: 'Existing Streets',
      },
    ],
    direction: 'horizontal',
    initialPosition: 50,
  },
  'design-vs-bike-trails': {
    id: 'design-vs-bike-trails',
    label: 'Design vs Bike Trails',
    description: 'CIP trail/bike projects vs existing bike trails',
    leadingLayers: [
      {
        url: 'https://services.arcgis.com/pfd9xSB0fCRnWvDl/ArcGIS/rest/services/InfrastructureProjects_capitalimprovementplan_f591509610ce45e6a910f3852498f4a4/FeatureServer/0',
        title: 'CIP — Bike / Trail Projects',
      },
    ],
    trailingLayers: [
      {
        url: 'https://services.arcgis.com/pfd9xSB0fCRnWvDl/ArcGIS/rest/services/Existing_bike_trail/FeatureServer/0',
        title: 'Existing Bike Trails',
      },
    ],
    direction: 'horizontal',
    initialPosition: 50,
  },
};
